import React from 'react';

export default function LabeledSelect({ label, value, onChange, children, className = '' }) {
  return (
    <div className={`d-flex flex-column ${className}`}>
      <div className="mb-1 fw-medium">{label}</div>
      <select className="bg-base p-1 w-100" value={value} onChange={onChange}>
        {children}
      </select>
    </div>
  );
}
